module.exports = __webpack_public_path__ + "videos/mts-products-chats-chats-and-channels.29c6a78.webm";